import React from 'react';
import { useSelector } from 'react-redux';
import { getUserName } from '@redux/selectors/UserSelector';

import Button from 'react-bootstrap/Button';
import REMapListIcon from '@images/logos/logop9map.png';
import REMapListPlaceholder from '@images/logos/remaplist-placeholder.jpg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const REMapListWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <>
      <div className="panel-content text-center rounded" style={{ background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${REMapListPlaceholder})`, minHeight: '231px' }}>
        <img alt="REMapList-icon" src={REMapListIcon} className="img-fluid mb-3" />
        <p className="mb-4" style={{ color: 'var(--darkBackground-4)', textShadow: '0 1px 0 rgba(255, 255, 255, 0.6)' }}>
          <strong>REMapList™ </strong>
          is an intuitive mapping tool using data from the Matrix™ and other data sources to provide members with a dynamic mapping experience.
        </p>
        <Button
          onClick={() => {
            window.open('https://maps.pillarnine.com', '_blank');
            gaEventTracker('Opened REMapList', `${username}`);
          }}
          variant="primary"
        >
          <i className="far fa-external-link mr-2" />
          REMapList™
        </Button>
      </div>
    </>
  );
};

export default REMapListWidget;
